export default function usePermissionsComposable( permission: string,
    permissions: any[],
    isAgent: boolean = false)  
     {

      if (isAgent) return true;
  
      return permissions?.some((p: any) => {
        if (p?.children != null) {
          if (p.action === permission && p.enabled) {
            return true;
          } else {
            const result = p.children.some(
              (c: any) => c.action === permission && c.enabled
            );
            return result;
          }
        } else {
          return p.action === permission && p.enabled;
        }
      });
  }